export default {
  mixpanelToken: 'b521100523c87555726690d9f4ffe958',
  hcaptchaSiteKey: '018d304b-5ec3-4c3e-84e1-898ddf8cdec8',
};
